import * as React from 'react';
import {
    Box,
    InputAdornment,
    TextField,
    Typography,
    styled,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { QuotationMarginProps } from '../../../models/quotations/Quotation';

const Container = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'stretch',
    gap: '6px',
}));

const Input = styled(TextField)(() => ({
    backgroundColor: 'white',
    width: '100%',
}));

export const QuotationProductsMargin: React.FC<QuotationMarginProps> = (
    props
) => {
    const { margin, net_price, handleChange, orientation = 'column' } = props;
    const [marginFix, setMarginFix] = useState<number>(margin);
    const [marginPercent, setMarginPercent] = useState<number>(
        Number(((margin / net_price) * 100).toFixed(0))
    );

    useEffect((): void => {
        setMarginPercent(Number(((margin / net_price) * 100).toFixed(0)));
        setMarginFix(margin);
    }, [margin]);

    const fixMarginChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = (event.target as HTMLInputElement).value;
        setMarginFix(Number(value));
        setMarginPercent(
            Number(((Number(value) / net_price) * 100).toFixed(0))
        );
        handleChange({
            margin: Number(value),
        });
    };

    const percentMarginChanged = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = Number((event.target as HTMLInputElement).value);
        setMarginPercent(value);
        setMarginFix(Number(((value / 100) * net_price).toFixed(0)));
        handleChange({
            margin: Number(((value / 100) * net_price).toFixed(0)),
        });
    };

    return (
        <Container sx={{ flexDirection: orientation }}>
            <Input
                value={marginFix}
                onChange={fixMarginChanged}
                type="number"
                InputProps={{
                    inputProps: { min: 0 },
                    endAdornment: (
                        <InputAdornment position="end">
                            <Typography variant="caption">Ft</Typography>
                        </InputAdornment>
                    ),
                }}
            />
            <Input
                value={marginPercent}
                onChange={percentMarginChanged}
                type="number"
                InputProps={{
                    inputProps: { min: 0 },
                    endAdornment: (
                        <InputAdornment position="end">
                            <Typography variant="caption">%</Typography>
                        </InputAdornment>
                    ),
                }}
            />
        </Container>
    );
};
